module.exports = __webpack_public_path__ + "img/settings.f071516b.svg";